export default __webpack_public_path__ + "static/media/Group1104.34548c92.svg";